import * as React from 'react'
import { t as typy } from 'typy'
import { inject, observer } from 'mobx-react'

import Image from 'src/components/UI/Image/Image'
import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'

import PaymentMethods from './PaymentMethods'
import styles from './Footer.module.scss'
import Newsletter from '../Newsletter/Newsletter'

type Props = {
  cart?: any
  footer: any
}

@inject('cart')
@observer
class Footer extends React.Component<Props> {
  // handleCountryChange = (e: any) => {
  //   const { cart } = this.props
  //   e.preventDefault()
  //   e.stopPropagation()
  //   if (cart && e.target.value) {
  //     console.log('CHANGE COUNTRY')
  //     cart.setCountry(e.target.value)
  //   }
  // }

  render() {
    const { footer } = this.props
    const links = typy(footer, 'links').safeObject
    const shortDescription = typy(footer, 'shortDescription').safeObject
    const logo = typy(footer, 'logotype.fields.file.url').safeObject
    const logoAlt = typy(footer, 'logotype.fields.file.url').safeObject
    const paymentMethods = typy(footer, 'paymentMethods').safeObject

    return (
      <footer className={styles.footer + ' aino-main-header'}>
        <div className={styles.upperSection}>
          <div className={styles.info}>
            {logo && (
              <Image className={styles.logotype} src={logo} alt={logoAlt} />
            )}
            {shortDescription && (
              <p className={styles.shortDescription}>{shortDescription}</p>
            )}
          </div>
          {links && (
            <div className={styles.links}>
              {links.map((link: any, index: number) =>
                link && link.fields ? (
                  <LinkComponent key={index} to={link.fields.slug}>
                    {link.fields.title}
                  </LinkComponent>
                ) : null
              )}
            </div>
          )}
          <Newsletter />
        </div>
        {paymentMethods && (
          <PaymentMethods
            wrapperStyles={styles.payments}
            methods={paymentMethods}
          />
        )}
      </footer>
    )
  }
}

export default Footer
